import { CUSTOM_SX_STATE_KEY } from '../../../../utils/richText/customSx';

/** Parses the custom sx assigned in the editor. Invalid or non-object JSON is ignored. */
export const stateToCustomSx = (state?: Record<string, unknown>) => {
  const value = state?.[CUSTOM_SX_STATE_KEY];
  if (typeof value !== 'string' || !value) return undefined;

  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed
      : undefined;
  } catch {
    return undefined;
  }
};
